<div class="alert p-2" [ngClass]="'alert-' + type + ' ' + class">
  <div class="d-flex justify-content-between align-items-center">
    <div class="p-2"><ng-content></ng-content></div>
    <div class="pointer p-2" (click)="onCloseClicked()">x</div>
  </div>
</div>
